export let tourContent = [
	{
		title: 'Bruny Island Day Tour',
		productCode: 'P18ZC5', // Replace with your actual product code
		headline: 'Explore Beautiful Bruny',
		description: `
        <p class="leading-7 [&:not(:first-child)]:mt-6">
            Arguably Tasmania's best day trip! At the end of this day, you will understand why the
            tourist numbers have doubled in the past 4 years! Bruny Island has a little bit of
            everything mainland Tasmania has - world class beaches, national parks, rugged coastline and
            native wildlife matched with the finest local produce from the ocean and the land.
        </p>
        <p class="leading-7 [&:not(:first-child)]:mt-6">
            While it's impossible to do everything in one day, we have designed various tours to fit in
            with the day’s weather conditions so we can provide the most enjoyable experience. You can
            expect an active (easy/moderate level) morning with nature walks, albino wallaby spotting,
            spectacular scenery lookouts, exploring pristine beaches and lagoon (swimming optional).
            This tour takes you off the beaten track and into areas that are only accessible by walking
            tracks that only locals know about.
        </p>
        <p class="leading-7 [&:not(:first-child)]:mt-6">
            After an adventurous morning, it will be time to pull it back a gear as we head for lunch at
            the Bruny Hotel, with many options to suit budgets and dietary requirements. After lunch,
            unwind and relax as we sample some award winning local produce. Honey, chocolate fudge,
            cheese, beverages and oysters are all possibilities (time pending and at own cost)!
        </p>
        <ul class="my-6 ml-6 list-disc [&>li]:mt-2">
            <li>We offer pick ups in and around the Hobart CBD.</li>
            <li>Tours start from Hobart at 7:30 am and arrives back around 5:30 pm</li>
            <li>
                Specific pickups available en route to Kettering (Ferry terminal) phone or email for more
                details
            </li>
            <li>There are opportunities throughout the day to buy food and drink.</li>
            <li>
                If there is something specific that you really want to see and do at Bruny Island, please
                just let your guide know and we will do our very best to ensure it happens.
            </li>
        </ul>
        <p class="leading-7 [&:not(:first-child)]:mt-6">
            <strong>Parks Pass Important Information:</strong> Please note that a Parks Pass will be required while on this tour. We recommend purchasing a Parks Pass prior to your tour <a class="underline" href="https://passes.parks.tas.gov.au/" target="_blank" rel="noopener noreferrer">here</a>. Alternatively, you can purchase a Parks Pass via phone during the day.
        </p>
        <p class="leading-7 [&:not(:first-child)]:mt-6">
            We pride ourselves on selling fun, which you are sure to experience onboard Tassie Tours Tasmania. See you soon!
        </p>
        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Tempered rainforest walk',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            This casual walk will take you through a lush rainforest that runs alongside the
                            relaxing Waterfall Creek.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                            This easy, twenty minute walk will allow you to take in the beautiful scenery and
                            peaceful ambience of the rainforest whilst breathing in some of the freshest air
                            Tasmania has to offer.
                        </p>`,
				image: '/src/lib/assets/highlights/bruny-island-1.jpg'
			},
			{
				title: 'Picturesque beaches',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            Bruny Island is home to countless beaches, each as picturesque as the other.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                            Be prepared to be in awe of their natural beauty, clear water and pristine sand as you visit some of our favourite beaches on the island.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                            We will bring along our bat and ball if you are up for a game of beach cricket!
                        </p>`,
				image: '/src/lib/assets/highlights/hero-carousel-1.jpg'
			},
			{
				title: 'Viewing platform at the Neck',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            Here is your next Instagram shot! Arguably the most iconic and most recognised landmark on the island, the lookout at the Neck never fails to disappoint.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                          Walk up the 279 timber steps to be rewarded with breathtaking 360 degree views of the island. Alongside the spectacular views, keep an eye out in the dunes for some burrows, fairy penguins and mutton birds nest here!
                        </p>
                       `,
				image: '/src/lib/assets/highlights/bruny-2.png'
			},
			{
				title: 'Wildlife spotting',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            Keep on the lookout! Bruny Island is a haven for a variety of Tasmania's unique native wildlife. Perhaps the most special is the albino wallaby, a rare species that is thriving on the island.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                          Keep your cameras at the ready on our walks and when we take you to a secret spot that the illusive albino wallaby is known to visit. You never know your luck!
                        </p>
                       `,
				image: '/src/lib/assets/highlights/bruny-island-day-tour.jpg'
			},
			{
				title: 'Walking tracks',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            Depending on the days forecast, the track we choose to take you on will vary. Rest assured that each track offers something unique to experience.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                         From visiting the second tallest sea cliffs in Australia and the spectacular views they offer to exploring secluded beaches to soaking up amazing views from panoramic lookouts, you are sure to be impressed.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                         These walks vary in duration and require a moderate level of fitness.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/walking-tracks.jpg'
			},
			{
				title: 'Cape Bruny Light house',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                         Located at the southern tip of the island, the convict built Cape Bruny Lighthouse is now the second oldest lighthouse tower in Australia (1836).
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                         Whilst visiting, soak up the gorgeous views of the southern ocean and the rugged sea cliffs that form the coastline of Cape Bruny.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/lighthouse.jpg'
			},
			{
				title: 'Lunch stop',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                         Our lunch stop will be at one of two locations depending on the day.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                        Based on which location we choose to eat lunch, you will have the option of dining in at the Bruny Island Hotel or grabbing some food from the general store next door. There's plenty of space for you to sit down either at the benches or at the beach.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                      If you would prefer to bring your own lunch for the day, you are more than welcome to.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/oysters.jpg'
			},
			{
				title: 'Sample award winning food',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                         If the natural beauty of the island isn't enough, Bruny has a range of gourmet produce that is guaranteed to please every food lover.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                        We will be stopping at a variety of locations where you can meet the locals and sample their mouth watering produce on offer.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                      Potential tastings include: berries, cheese, chocolate, fresh oysters, wine, beer and cider.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/food.jpg'
			}
		]
	},
	{
		title: 'Port Arthur Shuttle and Tasman Sights',
		productCode: 'PJHLE0', // Replace with your actual product code
		headline: 'Explore Port Arthur and Tasman Sights',
		description: `
        <p class="leading-7 [&:not(:first-child)]:mt-6">
				Looking to visit the multi-award winning UNESCO World Heritage Site Port Arthur? Want the
				added bonus of visiting some of the Tasman Peninsula highlights? Or simply just need
				transportation to the area? Then we have you covered!
			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				Port Arthur and the Tasman Peninsula are a must see and one of Tasmania's most popular
				tourist attractions. With its rich history and spectacular scenery on offer, it is easy to
				see why! Our popular 8 hour tour allows you to experience it all. Jump aboard with one of
				our friendly, local drivers who will be keen to show you a fantastic day!
			</p>
			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">How it works</h3>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				Departing Hobart 9:30am or select the 9:45am pickup at the Airport Travelodge. Included in
				the 1-way shuttle to Port Arthur is Pirates bay lookout, Dog line, Tasmanian Lavender Farm,
				Foundry Chocolate (see tour description above). You will arrive at Port Arthur at 12pm.
			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				Departing Port Arthur at 4pm and heading directly back to Hobart having you dropped off at
				the Airport 5:10 pm or Hobart CBD at 5:30pm.
			</p>
			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">
				Please note - before you book:
			</h3>
			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				<li>To book a one-way ticket, use promo code "ONEWAY"</li>
				<li>Entry fees are not included.</li>
				<li>
					This is a scheduled shuttle service. If you are late to your pickup point in either Hobart
					or Port Arthur the bus cannot wait. There will be no refunds for missed buses.
				</li>

				<li>
					If you would like to pre-book tours at Port Arthur please go direct to Port Arthur
					Historic site, we do not sell site entry tickets unless you are a group booking of 6 or
					more. There are many tours and packages to choose from. Any tours booked must fit in with
					the 12pm arrival and the 4pm departure.
				</li>
				<li>Please indicate if you are carrying excess baggage.</li>
				<li>
					No tickets are sold at any of the stops. You MUST pre-purchase your ticket and select a
					pick up location. There are no sales at any of the stops.
				</li>
				<li>
					Please make sure you give yourself plenty of time to arrive at your pickup location.
				</li>
			</ul>
        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Pirates Bay Lookout',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            With a panoramic view over Pirates Bay, this is an ideal stop to stretch your legs and breathe in the crisp, fresh Tasman peninsula air all while taking in its breathtaking views.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                            The Tasman peninsula is home to the largest sea cliffs in the Southern Hemisphere. On a clear day, you can see Cape Raoul, the candlestick and the Hippolyte. The rugged coastline and the rolling dense eucalyptus hills really do set the tone for why Port Arthur Prison was an ideal location.
                        </p>`,
				image: '/src/lib/assets/highlights/pirates-bay.png'
			},
			{
				title: 'Dog Line',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            The 30-meter-wide isthmus that leads to Port Arthur was once guarded by a line of up to nine ferocious dogs. A life-size replica of this infamous scene can be found on shore, setting the scene to how difficult it would have been to escape the Tasman peninsula through this narrow piece of land.
                        </p>
                      `,
				image: '/src/lib/assets/highlights/dog-line.png'
			},
			{
				title: 'Chocolate Foundry',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                           A 10-15 minute stop at the foundry chocolate is enough time to appease that sweet tooth. You can indulge or line the pockets with a large range of handmade chocolates. There are plenty of treats and gifts to satisfy all taste buds.
                        </p>

                       `,
				image: '/src/lib/assets/highlights/choc-foundry.jpg'
			},
			{
				title: 'Tasmanian Lavender Company',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                         Soak up the aroma as you walk through the fields of this ancient fragrant plant at the family-owned and operated farm which overlooks Long Bay on the doorstep of Port Arthur.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                         You have 20 minutes to explore the gift shop, sample or buy their lavender produce or simply purchase a coffee and morning tea/lunch and go for a stroll through the garden. If 20 minutes isn't enough there is an option to stay longer. Our guide will come back to collect you after dropping off the other customers at the historical site by 12 pm.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/lavender.jpg'
			},
			{
				title: 'Port Arthur Historic Site',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                           Immerse yourself into the dark eerie past of Port Arthur convict penal settlement dating back to 1830. Port Arthur is one of Australia's most important colonial landmarks and one of Tasmania's most iconic tourist attractions.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                         Winning multiple national tourism awards you will have the option of 3 or 4 hours to explore the site where there are more than 30 colonial buildings, ruins and restored homes as part of the UNESCO world heritage listed site. Your entry includes a 20-minute harbour cruise, an audio experience and complimentary key talks at locations throughout the day. A day and experience not to be missed and one to be remembered.
                        </p>

                       `,
				image: '/src/lib/assets/highlights/historic-site.jpg'
			},
			{
				title: 'Remarkable Caves',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                         Enjoy the vista from the Maingon Bay lookout, overlooking the Southern Ocean, watch the wild waves crash against the coastal sea cliffs and take in exceptional views of Penguin rocks and the bay. Descend down 115 steps to the view called remarkable caves. Surrounded by ancient sandstone cliffs and the view through the cave itself, it is well worth the descent.
                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
                        At certain times of the year and weather conditions and tides the water rushes through the cave. Be prepared to get a little wet should the conditions align. This is a 1-hour round trip from the Port Arthur historic site.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/remarkable.png'
			}
		]
	},
	{
		title: 'Hastings cave, Tahune Airwalk and Huon tasting trail',
		productCode: 'PTC0KJ', // Replace with your actual product code
		headline:
			'Take a spectacular day trip from Hobart through the Huon Valley to the Deep South of Tasmania. Highlights include the Tahune Airwalk, Hastings Caves and the tasting trail of the Huon valley.',
		description: `
        <p class="leading-7 [&:not(:first-child)]:mt-6">
				Join us for an unforgettable day tour exploring the pristine beauty of Tasmania's deep South, where the apples are crisp, the salmon is fresh, and the trees have been around since before your great-great-grandparents were born!
			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				Our first stop is Huonville, where you'll have a chance to grab a takeaway coffee and stock up on any essentials for the day. Sit back, relax, and enjoy the scenic drive along the beautiful Huon River. As you sip your coffee, you'll hear tales about why this area is famous for its apple orchards, craft cider makers, boutique winemakers, and salmon production.
			</p>

			<p class="leading-7 [&:not(:first-child)]:mt-6">
				Next, we arrive at the Tahune Airwalk, where you'll have two glorious hours to explore this spectacular region. Choose one or all three of the walks on offer. Start with the famous Airwalk, a 600-meter stroll 50 meters up in the tree canopy amongst the world's tallest flowering plants, the eucalyptus gum trees. Feeling adventurous? Take on the Swinging Bridges Track, a 3.4-kilometer jaunt where you'll cross two swinging bridges over the Huon River the first (100m long) and the Picton Swinging Bridge (64m long). Alternatively, you can stay on the ground and enjoy the tranquillity of strolling along the riverbank through ancient Huon pines, mingling with trees that are 2,500 years old. Talk about a walk-through of ancient times!
			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				After lunch, it's time to venture further south to the magical Hastings Caves, where you'll marvel at the underground wonders of Australia's largest dolomite cave. Your entrance ticket (included) grants you a guided tour through this fascinating cave system, led by an experienced and passionate guide. Here you can admire the intricate formations and learn about the area's geological history. While exploring the Hastings Caves State Reserve, keep your eyes peeled for native wildlife like platypus, quolls, pademelons and birds.
			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				On our way back to Hobart, we'll stop at one of the local cider producers where you can enjoy a tasting paddle with both alcoholic and non-alcoholic options or indulge in a complimentary mouth-watering apple pie (seasonal) if your stomach desires. It's the perfect way to wrap up a day of exploring. There's truly nothing better than sitting back, relaxing in a historic venue, enjoying a drink, and sharing stories with your fellow adventurers.
			</p>
			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				<li>10 hour tour. Departs Hobart 7:30 am returns 5:30 pm</li>
			</ul>

			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">
				Inclusions:
			</h3>
			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				<li>Selected Hobart CBD hotel pick up/drop off - 10 hour tour</li>
				<li>Guided tour through Hastings Caves (ticket price included)</li>
				<li>
					Guided tour
				</li>
				<li>Comfortable air conditioned transportation </li>
			</ul>
			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">
				Exclusions:
			</h3>
			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				<li>Meals and drink at own cost, Lunch and snack options available throughout the day.</li>
				<li>Beverages </li>
				<li>
					Tahune Airwalk entrance fee.
				</li>
			</ul>
			<table class="mt-6 min-w-full divide-y divide-gray-300">
				<thead>
					<tr>
						<th
							scope="col"
							class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-500 sm:pl-0"
							>Adult</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>Concession</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>Child (5-16 years)</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>Infant (0-4 years)</th
						>
					</tr>
				</thead>
				<tbody class="divide-y divide-gray-200">
					<tr>
						<td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
							>$32.00</td
						>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">$28.80</td>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">$16.00</td>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">FREE</td>
					</tr>
				</tbody>
			</table>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			*Family Pass (2 adults, 3 children): $80.00
			</p>
        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Huonville Coffee and Scenic Drive',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
                            Begin your journey with a takeaway coffee in Huonville, setting the stage for a relaxing drive along the picturesque Huon River. Enjoy tales of the region's rich history in apple orchards and salmon production.
                        </p>
                       `,
				image: '/src/lib/assets/highlights/scenic.jpg'
			},
			{
				title: 'Tahune Airwalk Adventure',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Explore the Tahune Airwalk, where you can walk 50 meters above the ground among towering eucalyptus trees. Choose from multiple trails, including the adventurous Swinging Bridges Track, for a unique treetop experience.                        </p>
                      `,
				image: '/src/lib/assets/highlights/tahune.jpg'
			},
			{
				title: 'Stroll Among Ancient Huon Pines',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Take a tranquil walk along the riverbank through ancient Huon pines, some of which are 2,500 years old. This peaceful stroll offers a glimpse into the ancient natural history of the region.                        </p>

                       `,
				image: '/src/lib/assets/highlights/huon-pine.jpg'
			},
			{
				title: 'Hastings Caves Exploration',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Discover the underground wonders of Hastings Caves, Australia's largest dolomite cave. A guided tour reveals intricate formations and fascinating geological history, providing an unforgettable subterranean adventure.                        </p>

                       `,
				image: '/src/lib/assets/highlights/hastings-1.jpg'
			},
			{
				title: 'Huon Valley Tasting Board',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Savour a delightful tasting board featuring the Huon Valley's finest produce, including smoked salmon, cheeses, and freshly baked bread. This culinary experience celebrates the region's rich flavors.                        </p>


                       `,
				image: '/src/lib/assets/highlights/tasting-board.jpg'
			},
			{
				title: 'Cider Tasting and Apple Crumble Finale',
				content: `
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
Conclude your tour with a visit to a local cider producer, where you can enjoy a tasting paddle or indulge in a seasonal apple crumble. Relax in a historic venue and share stories with fellow adventurers.                        </p>
                       `,
				image: '/src/lib/assets/highlights/cider-board.jpg'
			}
		]
	},
	{
		title: 'A Day At Wineglass Bay',
		productCode: 'PNNK81', // Replace with your actual product code
		headline: `Discover Tasmania's East Coast with our Wineglass Bay Day Tour`,
		description: `
        <p class="leading-7 [&:not(:first-child)]:mt-6">
        Join us for an unforgettable adventure along Tasmania’s stunning East Coast with our flexible Wineglass Bay tour, designed to cater to your individual preferences.
			</p>
			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">
			Itinerary
			</h3>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			For the avid hikers, you’ll have up to 4 hours to explore Freycinet National Park at your own pace. Choose from an array of trails, including the iconic Wineglass Bay hike or the challenging ascent to Mt. Amos, where you’ll be rewarded with breathtaking panoramic views. Here, you can soak in the beauty of this world-renowned beach, with its pristine white sands and turquoise waters, inviting you in after a morning of hiking. Don’t worry about going hungry; you’ll have the option to grab a packed lunch to enjoy during your adventure.			</p>

			<p class="leading-7 [&:not(:first-child)]:mt-6">
			If you prefer a more relaxed experience, our knowledgeable guide will lead you on a scenic walk to the Wineglass Bay lookout, where you’ll take in the stunning views. This moderate 40-minute hike uphill is well worth the effort. After soaking in those magnificent sights, we’ll descend for a leisurely stroll around the Cape Tourville Lighthouse, taking in the breathtaking coastal scenery. 			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			Once you’ve worked up a sweat, it’s time for a refreshing swim at Honeymoon Bay—a local favorite. With its orange-capped granite rocks, crystal clear waters, and pristine white sands, Honeymoon Bay offers the perfect spot to refresh. After a swim, you’ll feel completely rejuvenated—and have plenty of stunning photos for your Insta feed!			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			To top off your day, you will have the opportunity to a taste some of Tasmania's freshest seafood at the Freycinet Marine Farm. Indulge in local delicacies like oysters, prawns, and crayfish, and while you're in the area, why not sample one of the region's award-winning wines? Sit back, relax, and enjoy the company of your fellow travelers—there’s something to satisfy everyone’s palate.		</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			For those who spent the day hiking, a refreshing drink and a quick takeaway meal will be available to recharge before we head to our final stop.	</p>

			<p class="leading-7 [&:not(:first-child)]:mt-6">
			Our last stop before we make our way back to Hobart will be a delicious ice cream, the perfect sweet treat to end your day of adventure and exploration.			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			Whether you’re seeking adventure or relaxation, our Wineglass Bay tour has it all. Come and experience the beauty of Tasmania!			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
			Meal Options:			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-2 ">
			Enjoy a takeaway breakfast at Orford and pick up snacks and lunch for your hike.	</p>


        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Flexible Hiking Options',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
				Explore Freycinet National Park at your own pace for up to 4 hours, choosing from iconic trails like the Wineglass Bay hike or the challenging Mt. Amos ascent with panoramic views.                        </p>
                       `,
				image: '/src/lib/assets/highlights/wb-2.jpg'
			},
			{
				title: 'Scenic Walk to Wineglass Bay Lookout',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
A 40-minute moderate hike with a guide to the lookout, offering breathtaking views of Wineglass Bay.                    </p>
                      `,
				image: '/src/lib/assets/highlights/wb-1.jpg'
			},
			{
				title: 'Cape Tourville Lighthouse Walk',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
A leisurely stroll around the lighthouse, taking in stunning coastal scenery.                        </p>

                       `,
				image: '/src/lib/assets/highlights/wineglass-bay.jpg'
			},
			{
				title: 'Refreshing Swim at Honeymoon Bay',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Swim in the crystal-clear waters of Honeymoon Bay, with its orange-capped granite rocks and soft white sands.                       </p>

                       `,
				image: '/src/lib/assets/highlights/wb-5.jpg'
			},
			{
				title: 'Tasmanian Seafood at the award-winning Freycinet Marine Farm',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Savor fresh oysters, prawns, crayfish, and other local seafood, paired with award-winning regional wines.                        </p>


                       `,
				image: '/src/lib/assets/highlights/wb-3.jpg'
			},
			{
				title: 'Quick Refreshments for Hikers',
				content: `
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
Enjoy a refreshing drink and takeaway meal to recharge after your hike.                        </p>
                       `,
				image: '/src/lib/assets/highlights/wb-6.jpg'
			},
			{
				title: 'Sweet End with an Ice Cream',
				content: `
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
The perfect treat to wrap up your day before heading back to Hobart.                     </p>
                       `,
				image: '/src/lib/assets/highlights/wb-4.jpg'
			}
		]
	},
	{
		title: 'Mount Field and the Derwent Tasting Trail ',
		productCode: 'PQ5CJC', // Replace with your actual product code
		headline: 'Nature, Wildlife and Culinary Delights',
		description: `
        <p class="leading-7 [&:not(:first-child)]:mt-6">
        Join us on this unforgettable tour where we explore two of Tasmania’s most iconic destinations, Mount Field and the Derwent Valley, combining the natural beauty of Mt Field National Park with its giant eucalyptus trees, ancient rainforest and stunning waterfalls and delicious local produce, of the Derwent Valley.			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
			Drive through the picturesque Derwent Valley region before reaching Mount Field National Park. Witness the most remarkable landscapes and step inside a part of the Tasmanian World Heritage Area. Being one of Australia’s oldest and most diverse national parks, with some of the tallest flowering trees in the world, Mount Field is full of natural wonders, abundant wildlife and ecological richness.			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
 For those interested, The Lady Barron Falls Circuit is a great short walk encompassing all the main points of interest within the lower section of Mount Field National Park. The walk takes in the beautiful Russell Falls & Horseshoe Falls, Tall Trees Walk and Lady Barron Falls. Taking just under 2 hours, this circuit covers an amazing array of landscapes in only 6km.	</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
Walk through the rainforest and admire the tall trees as you head to the iconic Russell Falls and Horseshoe Falls where cascading waterfalls await. Along the way, you may also spot native wildlife such as wallabies, echidnas, the unique platypus and various rare bird species that inhabit this environment.  			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
 In the afternoon consider exploring some options of locally-grown produce, along with tastings both alcoholic and non-alcoholic. Visit the Westerway Raspberry Farm (available November to June) to hand-pick a variety of berries, or explore the historic Salmon Ponds, the birthplace of trout in Australia, renowned for its famous pancakes. There is also the option to enjoy a tasting and grab a bite to eat at the family-owned Plenty Cider or the New Norfolk Rum Distillery. From heritage buildings to lush gardens and unique tastings, there is something for everyone. 		</p>

			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">Leaving and returning to Hobart</h3>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				Experience two of Tasmania's most iconic locations, Mount Field and the Derwent Valley.
			</p>

			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				    <li>We offer 11 pickup locations in and around the Hobart CBD.</li>
    <li>6 - 8 hour tour.</li>
    <li>Pickups start prior to 9:30am and finish at 3:30 or 5:30pm.</li>
    <li>National parks pass and tastings are not included.</li>
    <li>There are opportunities throughout the day to buy food and drinks.</li>

			</ul>
        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Russell and Horseshoe Falls',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Some of Tasmania's most famous waterfalls, these locations feature stunning multi-tiered cascade waterfalls that flow gracefully over horizontal rock layers.                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
They are easily accessible natural wonders and a must-see within Mount Field National Park.                        </p>`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: 'Flora and Fauna',
				content: `
                <p class="leading-7 [&:not(:first-child)]:mt-6">
                            The 30-meter-wiMount Field National Park is a haven for diverse wildlife, offering visitors a chance to encounter many of Tasmania's native species in their natural habitat. Here are some highlights: Wallabies, the Eastern Quoll, Yellow Wattlebird, platypus, and the echidna.de isthmus that leads to Port Arthur was once guarded by a line of up to nine ferocious dogs. A life-size replica of this infamous scene can be found on shore, setting the scene to how difficult it would have been to escape the Tasman peninsula through this narrow piece of land.
                        </p>
                <p class="leading-7 [&:not(:first-child)]:mt-6">
Mount Field is home to many plant species that are found nowhere else in the world, from eucalypt trees, alpine wildflowers, pandani plants and sassafras.                        </p>
                      `,
				image: '/src/lib/assets/highlights/wildlife.jpg'
			},
			// 			{
			// 				title: 'Mona Museum',
			// 				content: `
			//                 <p class="leading-7 [&:not(:first-child)]:mt-6">
			// MONA is Australia's largest private museum and one of the most controversial private collections of modern art and antiquities.                        </p>
			//                 <p class="leading-7 [&:not(:first-child)]:mt-6">
			// Here you can explore the museum or simply sit back and relax whilst sampling local produce and tastings at the Moorilla Wine Bar or Moo Brew Bar. You might even get lucky with some live music on the lawn!                         </p>

			//                        `,
			// 				image: '/src/lib/assets/highlights/mona.jpg'
			// 			},
			{
				title: 'Westerway Raspberries',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Westerway Raspberry Farm has been supplying thousands of kilograms of fresh and frozen raspberries, blackcurrants, blackberries and other seasonal soft fruits to Tasmanian and Australian markets for over 20 years.                         </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
This is a great opportunity to try some fresh local produce and hand-pick your favourite berries or try some berry ice cream.                        </p>
                       `,
				image: '/src/lib/assets/highlights/raspberries.jpg'
			},
			{
				title: 'Salmon Ponds',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
A unique part of Tasmania's history with the oldest trout hatchery in the Southern Hemisphere!                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
From the hatchery, the museum, feeding the fish, the heritage garden and the cafe, famous for its crepes and pancakes, Salmon Ponds is the perfect stop on your journey back to Hobart.                        </p>

                       `,
				image: '/src/lib/assets/highlights/salmon-ponds.jpg'
			},
			{
				title: 'Plenty Cider',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Made from 100% locally sourced fruit, Plenty Cider offers a range of unique Tasmanian craft cider, try a tasting paddle (alcoholic or non-alcoholic) or grab a bite to eat such as a grazing platter at their cidery.                         </p>

                       `,
				image: '/src/lib/assets/highlights/cider.jpg'
			},
			{
				title: 'The Derwent Valley region',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
One of Tasmania's most breathtakingly diverse wine regions where you'll also find a historical village, quaint shops, vineyards, cideries and Tasmania's first rum Distillery anchored in a former asylum.                        </p>

                       `,
				image: '/src/lib/assets/highlights/derwent.jpg'
			}
		]
	},
	{
		title: 'Cradle Mountain in a day from Hobart',
		productCode: 'PP0SGV', // Replace with your actual product code
		headline: 'Discover a wilderness adventure on our Cradle Mountain Tour',
		description: `
        <p class="leading-7 [&:not(:first-child)]:mt-6">
Recognised worldwide for its sheer beauty, Cradle Mountain is not to be missed while visiting Tasmania. Once thought to be impossible, but due to high demand, here it is: Hobart to Cradle Mountain and back in a day!			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
Join us on this 14 hour day tour and enjoy the scenic beauty as we make our way north from Hobart. The 4 hour drive each way is broken into 2 x 2 hour intervals to stretch the legs, grab a coffee and something to eat (at own cost). 			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
 Upon arrival at the Information Centre on the doorstep of Cradle Mountain, we will stock up on fluids and make our way to the shores of Dove Lake where you will have 2 hours to wander around the Dove Lake circuit or choose one of the many other large or small walks. 			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
 Once Dove Lake has been explored and you’ve captured that prized Instagram photo, it’s time to move on to the Enchanted forest and King Billy Pine walks. These two exceptionally beautiful and ancient walks will have you gazing through the forest with amorous delight as you breathe in the crisp, pristine air from under the canopy of 4000 year old trees. Native wildlife is abundant in this area, so keep your eyes peeled and you may see the elusive Tasmanian Devil, wombats, Spotted Quolls, wallabies and more! 			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
 After 4.5 hours exploring it is time to make the mission back South. 			</p>
			<p class="font-semibold leading-7 [&:not(:first-child)]:mt-6">
 This tour departs Hobart at 6am and returns by 8pm 			</p>
			<h3 class="font-heading mt-8 scroll-m-20 text-2xl font-semibold tracking-tight">Cradle Mountain Tours Included/Highlights</h3>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				The only Cradle Mountain day tour departing from Hobart.
			</p>
			<p class="leading-7 [&:not(:first-child)]:mt-6">
				On arrival, you'll have 4.5 hours to explore this world-renowned landmark and be reinvigorated by mother nature's vibes in the amazing ancient forests of this world heritage wilderness site.
			</p>

			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				   <li>Transportation to Cradle Mountain and back to Hobart</li>
    <li>Guided commentary</li>
    <li>National park fees</li>
    <li>Walking tracks through world heritage listed national parks</li>
    <li>Wildlife spotting</li>
    <li>Chance to see wombats, wallabies, Tasmanian Devils, spotted-tail quolls, platypus and echidnas.</li>
			</ul>
        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Temperate rainforests',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
The region is home to ancient temperate rainforests, alpine heathlands, and
a variety of unique plant species, including the iconic King Billy pine and button grass plains.                       </p>
    `,
				image: '/src/lib/assets/highlights/canyon.jpg'
			},
			{
				title: 'Wildlife spotting',
				content: `
                <p class="leading-7 [&:not(:first-child)]:mt-6">
                            The area’s wildlife is equally impressive, with sightings of wombats, echidnas, and
the elusive Tasmanian devil. Birdwatchers will enjoy spotting species like the black currawong and
wedge-tailed eagle.
                        </p>

                      `,
				image: '/src/lib/assets/highlights/wildlife.jpg'
			},
			{
				title: 'Short walks',
				content: `
                <p class="leading-7 [&:not(:first-child)]:mt-6">
Each walk provides spectacular scenery, from serene lakes reflecting the sky to
panoramic views of the valleys and rugged mountain peaks. These short walks offer a perfect
opportunity to experience the diverse beauty of Cradle Mountain, combining peaceful natural
surroundings with breathtaking vistas.                       </p>


                       `,
				image: '/src/lib/assets/highlights/walks.jpg'
			}
		]
	},
	{
		title: 'Nipaluna (Hobart) Highlights',
		productCode: 'PQKW4C', // Replace with your actual product code
		headline: 'Discover Nipaluna (Hobart) Today',
		description: `
	        <a href="/nipaluna-hobart-highlights.pdf" target="_blank" class="leading-7 [&:not(:first-child)]:mt-6 underline hover:opacity-80 ">
									Download information brochure	</a>
	        <p class="leading-7 [&:not(:first-child)]:mt-6">
	Enjoy Hobart's spectacular backdrop, kunanyi (Mt. Wellington). Breathe in the pristine Tasmanian air as we drive up the 1272m to the pinnacle where you will be greeted by the very best view of Hobart and surrounds. Up there you will have 30 minutes to explore the short boardwalks lookouts or spend your time in the observation and information shelter.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Step back in time as you explore Richmond, a quaint little township nestled in the heart of the Coal Valley wine region. Walk the streets of this iconic township which is rich in convict history, sandstone colonial buildings and home to Australia's oldest bridge, catholic church and oldest intact gaol. A great place to sample some local food and wine, have some lunch and visit the many quaint local art and craft shops.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	 A city loop with fully guided commentary as we drive you around the streets of nipaluna (Hobart). It covers all the important locations and landmarks across the Hobart CBD and beyond. Expect to see Salamanca Place, Parliament House, Cascade Brewery, Female Factory, Battery Point, Tasman Bridge and many more.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	On Saturday's (only) we will have a 75 minute stop at Hobart's most visited tourist attraction the Salamanca market. With 300 stallholders, the market includes fresh local produce, delicious home grown food and drink and lots of souvenirs, gifts and many handmade products. A true cultural experience.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	We offer 9 convenient pickup locations in and around the city.			</p>
			<h3 class="mt-8 scroll-m-20 font-heading text-2xl font-semibold tracking-tight">Pricing</h3>
			<table class="mt-6 min-w-full divide-y divide-gray-300">
				<thead>
					<tr>
						<th
							scope="col"
							class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-500 sm:pl-0"
							>Adult</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>Concession</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>Child (5-12 years)</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>Infant (0-4 years)</th
						>
					</tr>
				</thead>
				<tbody class="divide-y divide-gray-200">
					<tr>
						<td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
							>$99.00</td
						>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">$80.00</td>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">$55.00</td>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">FREE</td>
					</tr>
				</tbody>
			</table>

	        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Salamanca markets (Saturday only)',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
	one of Australia's most celebrated outdoor markets - stretch
	along the historic waterfront precinct, nestled between picturesque sandstone warehouses dating
	back to the 1830s. With over 300 stalls, Salamanca Market offers a vibrant mix of local crafts,
	artisanal goods, fresh produce, gourmet foods, and unique souvenirs.                        </p>
						   `,
				image: '/src/lib/assets/highlights/markets.jpg'
			},
			{
				title: 'City Loop',
				content: `
					<p class="leading-7 [&:not(:first-child)]:mt-6">
							   Let your guide take you on a journey around Tasmania’s capital, Hobart, and witness the
	city's rich history, vibrant culture, and stunning natural beauty firsthand. This tour will immerse you in
	everything that makes Hobart unique, from its colonial past to its dynamic present.
							</p>
						  `,
				image: '/src/lib/assets/highlights/battery-point.jpg'
			},
			{
				title: 'Mount Wellington',
				content: `
					<p class="leading-7 [&:not(:first-child)]:mt-6">
	The journey to the top is an adventure, winding through lush temperate
	rainforests and unique alpine landscapes. Upon reaching the summit, breathtaking 360-degree views
	will greet you. On a clear day, you can see as far as Bruny Island, the Southern Ocean, and even
	parts of the World Heritage Wilderness Area.                       </p>


						   `,
				image: '/src/lib/assets/highlights/sunset.jpg'
			},
			{
				title: 'Wicked Cheese',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
	This family-owned business produces a range of award-winning cheeses, including
	creamy bries, sharp cheddars, and the Wicked Blue. Visitors to the cheesery can enjoy tastings,
	watch the cheese-making process, and purchase their favourite varieties along with other gourmet
	Tasmanian products.                      </p>

						   `,
				image: '/src/lib/assets/highlights/beer.jpeg'
			},
			{
				title: 'Richmond',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
	Richmond, established in the early 19th century, is renowned for its well-preserved
	Georgian architecture and charming atmosphere. The town's standout feature is the Richmond
	Bridge, Australia's oldest stone bridge, completed in 1823. Located in the picturesque Coal River
	Valley, Richmond's quaint streets are lined with historic buildings, boutique stores and cosy cafes.
	This makes it a favourite spot for history enthusiasts and those seeking a serene, scenic escape.                      </p>


						   `,
				image: '/src/lib/assets/highlights/salmon-ponds.jpg'
			}
		]
	},
	{
		title: 'Hobart Highlights Day Tour',
		productCode: 'PNVP8M', // Replace with your actual product code
		headline: "Hobart's best highlights",
		description: `
  <a href="/nipaluna-hobart-highlights.pdf" target="_blank" class="leading-7 [&:not(:first-child)]:mt-6 underline hover:opacity-80 ">
									Download information brochure	</a>
	        <p class="leading-7 [&:not(:first-child)]:mt-6">
	We begin the day with our city loop tour where we will provide guided commentary as we explore the streets of Hobart and visit its major attractions and landmarks. Our first destination is the awe-inspiring kunanyi, also known as Mt. Wellington, where you can indulge in the renowned pristine air of Tasmania. Ascend to the pinnacle at 1272m and be mesmerized by the breathtaking panoramic view of Hobart and its picturesque surroundings. Don't miss the opportunity to capture the perfect Instagram-worthy selfie against this stunning backdrop of Hobart and beyond.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Next, we'll venture to the renowned Salamanca Market, available on Saturdays only. This world-class market showcases the very best of Tasmanian culture, offering a delightful array of art, local produce, talented buskers, unique souvenirs, refreshing beverages, and much more! 			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	After exploring the market's offerings for 75 minutes, we will continue our journey through the scenic Coal River Valley wine region. This region is renowned for its award winning cool climate wines. Along the way, we will make a quick stop at the acclaimed Wicked Cheese, where you can enjoy a complimentary cheese sampling and an opportunity to purchase some local produce from the farm gate cafe. Then, we will proceed to the historic township of Richmond, which is rich in convict history and showcases magnificent sandstone and colonial buildings. Here, you will have the opportunity to admire Australia's oldest bridge and Catholic church. Richmond is also home to numerous charming eateries, making it the perfect spot for our lunch break. Additionally, we highly recommend visiting the Drink Tasmania Tasting House, where you can indulge in tastings of the region's finest wines, whisky, and local produce. 			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	To conclude our adventure-filled day, we'll visit the Bonorong Wildlife Sanctuary. Get up close and personal with the friendly kangaroos and other fascinating Tasmanian and Australian wildlife. Don't miss the chance to witness the famous Tasmanian Devil, a true highlight even for locals! 			</p>
			<h3 class="mt-8 scroll-m-20 font-heading text-2xl font-semibold tracking-tight">Bonorong Wildlife Sanctuary - entry cost</h3>
			<table class="mt-6 min-w-full divide-y divide-gray-300">
				<thead>
					<tr>
						<th
							scope="col"
							class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-500 sm:pl-0"
							>Adult</th
						>
						<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-500"
							>3-15 years</th
						>

					</tr>
				</thead>
				<tbody class="divide-y divide-gray-200">
					<tr>
						<td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0"
							>$33.50</td
						>
						<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-900">$19.50</td>

					</tr>
				</tbody>
			</table>
			<h3 class="mt-8 scroll-m-20 font-heading text-2xl font-semibold tracking-tight">Attractions List</h3>
			<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
				   <li>Mt Wellington - Take in the breath taking views 1272m above Hobart</li>
    <li>Richmond - Rich in convict history. Explore this Quaint little township </li>
    <li> City Loop - Guided commentary through the major attractions /landmarks </li>
    <li>Salamanca Market - 75 mins to enjoy one of the largest markets in the world.</li>
    <li>Bonorong - Hand feed Kangaroos and see all the unique Australian wildlife. </li>
    <li>Wicked Cheese - Award winning cheese maker. Free cheese sampling.</li>
			</ul>

	        `,
		accordionHeadline: 'Some of the things you can expect to see and do',
		accordionContent: [
			{
				title: 'Salamanca markets (Saturday only)',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
one of Australia's most celebrated outdoor markets - stretch
along the historic waterfront precinct, nestled between picturesque sandstone warehouses dating
back to the 1830s. With over 300 stalls, Salamanca Market offers a vibrant mix of local crafts,
artisanal goods, fresh produce, gourmet foods, and unique souvenirs.                        </p>
                       `,
				image: '/src/lib/assets/highlights/markets.jpg'
			},
			{
				title: 'City Loop',
				content: `
                <p class="leading-7 [&:not(:first-child)]:mt-6">
                           Let your guide take you on a journey around Tasmania’s capital, Hobart, and witness the
city's rich history, vibrant culture, and stunning natural beauty firsthand. This tour will immerse you in
everything that makes Hobart unique, from its colonial past to its dynamic present.
                        </p>
                      `,
				image: '/src/lib/assets/highlights/battery-point.jpg'
			},
			{
				title: 'Mount Wellington',
				content: `
                <p class="leading-7 [&:not(:first-child)]:mt-6">
The journey to the top is an adventure, winding through lush temperate
rainforests and unique alpine landscapes. Upon reaching the summit, breathtaking 360-degree views
will greet you. On a clear day, you can see as far as Bruny Island, the Southern Ocean, and even
parts of the World Heritage Wilderness Area.                       </p>


                       `,
				image: '/src/lib/assets/highlights/sunset.jpg'
			},
			{
				title: 'Wicked Cheese',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This family-owned business produces a range of award-winning cheeses, including
creamy bries, sharp cheddars, and the Wicked Blue. Visitors to the cheesery can enjoy tastings,
watch the cheese-making process, and purchase their favourite varieties along with other gourmet
Tasmanian products.                      </p>

                       `,
				image: '/src/lib/assets/highlights/beer.jpeg'
			},
			{
				title: 'Richmond',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Richmond, established in the early 19th century, is renowned for its well-preserved
Georgian architecture and charming atmosphere. The town's standout feature is the Richmond
Bridge, Australia's oldest stone bridge, completed in 1823. Located in the picturesque Coal River
Valley, Richmond's quaint streets are lined with historic buildings, boutique stores and cosy cafes.
This makes it a favourite spot for history enthusiasts and those seeking a serene, scenic escape.                      </p>


                       `,
				image: '/src/lib/assets/highlights/salmon-ponds.jpg'
			},
			{
				title: 'Bonorong Wildlife Sanctuary',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
The sanctuary is home to a variety of iconic Tasmanian species,
including Tasmanian devils, kangaroos, wombats, and koalas. Bonorong is dedicated to rescuing and
rehabilitating injured and orphaned wildlife, with a focus on education and conservation efforts.
Visitors can enjoy close-up encounters with the animals, guided tours, and interactive feeding
sessions.                      </p>

                       `,
				image: '/src/lib/assets/highlights/bonorong.png'
			}
		]
	},
	{
		title: 'kunanyi / Mt Wellington Shuttle',
		productCode: 'PMPLBM', // Replace with your actual product code
		headline: "Experience Mount Wellington's Spectacular Views",
		description: `
	        <p class="leading-7 [&:not(:first-child)]:mt-6">
	Visit the awe-inspiring kunanyi, also known as Mt. Wellington, where you can indulge in the renowned pristine air of Tasmania. Ascend to the pinnacle at 1272m and be mesmerized by the breathtaking panoramic view of Hobart and its picturesque surroundings. Don't miss the opportunity to capture the perfect Instagram-worthy selfie against this stunning backdrop of Hobart and beyond.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Guests will have 30 minutes to take in the best view in Hobart before returning to the city. 			</p>


	        `,
		accordionHeadline: 'Tour highlights',
		accordionContent: [
			{
				title: 'The view',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
The journey to the top is an adventure in itself, winding through lush temperate rainforests
and unique alpine landscapes.. upon reaching the summit, breathtaking 360-degree views greet you.
On a clear day, you can see as far as Bruny Island, the Southern Ocean, and even parts of the World
Heritage Wilderness Area.                 </p>
                       `,
				image: '/src/lib/assets/highlights/sunset.jpg'
			},
			{
				title: 'Flora and fauna',
				content: `
                <p class="leading-7 [&:not(:first-child)]:mt-6">
                           This mountain features a diverse range of flora and fauna due to its varied
elevations. The lower slopes are covered with eucalyptus forests, including Blue Gum and
Stringybark. Higher up, you'll find cool-climate plants like ferns and mosses. The area is also home to
birds such as the Tasmanian Native Hen and Black Currawong. Small marsupials and a variety of
insects also inhabit the region.
                        </p>
                      `,
				image: '/src/lib/assets/highlights/wildlife.jpg'
			}
		]
	},
	{
		productCode: 'P0V9R2', // Replace with your actual product code
		headline: 'The Ultimate Tasmanian Experience',
		description: `
	        <p class="leading-7 [&:not(:first-child)]:mt-6">
	Join this fully inclusive tour of Tasmania's most iconic locations with our friendly, local and knowledgeable guides for 11 days and 10 nights. This unforgettable experience will leave no stone unturned, embracing everything Tasmania has to offer.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Witness our dramatic coastlines, rare and remarkable wildlife in their natural habitat, rich convict history, eccentric art scene and eclectic food range. We can assure you there is something for everyone on this unique island down under.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Travel through the most spectacular regions of this extraordinary island state, taking in all the highlights from inspiring wildlife sanctuaries, beautiful winery regions, picturesque beaches, to wondrous cruises and wilderness train journeys, World Heritage listed convict sites and small historic villages.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Delve deep and uncover Tasmania's vast wilderness and untouched national parks, covered with a diversity of unspoiled habitats and ecosystems, you will experience first hand the natural, ancient beauty these places have to offer.			</p>
	<blockquote class="mt-6 border-l-2 pl-6 italic">
	ICONIC20 discount code valid only for the 11-day tour departing April 3-13, 2024. Subject to availability. Cannot be combined with other offers.
  </blockquote>

	        `,
		features: [
			{
				title: 'Transport',
				image: '/src/lib/assets/illustrations/transport.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>Small group touring</li>
    				<li>max 24 travellers</li>
				</ul>`
			},
			{
				title: 'Guides',
				image: '/src/lib/assets/illustrations/planning.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>1 - 3 guides throughout your tour</li>
    				<li>With alternating guides you will get the diverse knowledge perspective of different local experts</li>
				</ul>`
			},
			{
				title: 'Accommodation',
				image: '/src/lib/assets/illustrations/resting.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>Great twin share accommodation</li>
    				<li>8 nights 4 star hotels</li>
    				<li>2 nights 4 star cabin parks</li>
				</ul>
				<p class="leading-7 [&:not(:first-child)]:mt-4 text-xs italic">
	(Single supplement available)</p>`
			},
			{
				title: 'Food and Drink',
				image: '/src/lib/assets/illustrations/food.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>10 Breakfasts</li>
    				<li>5 Lunches</li>
    				<li>7 Dinners</li>
    				<li>2 Wineries with tastings</li>
    				<li>Iron House Brewery and Distillery with tasting</li>
    				<li>6 Produce samplings</li>
				</ul>`
			},
			{
				title: 'Activities',
				image: '/src/lib/assets/illustrations/bike.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>Bruny Island Wilderness Cruise</li>
    				<li>MONA Musuem and Ferry</li>
    				<li>Port Arthur Historic Site and harbor cruise</li>
    				<li>East Coast Nature World</li>
    				<li>Seahorse World OR Platypus House</li>
    				<li>Gordon River Cruise OR West Coast Wilderness railway</li>
    				<li>The Wall in the Wilderness</li>
    				<li>National Park Passes for Freycinet & Cradle Mountain</li>
				</ul>`
			}
		],
		accordionHeadline: 'Itinerary',
		accordionContent: [
			{
				title: '<p><strong>Day 1 - </strong> Arrivals day in Hobart</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our arrivals day is for passengers to settle into Hobart and unwind in their centrally located accommodation.                        </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
In the evening feel free to say hello to our team and fellow guests who you will be travelling with for the next 10 days. There will be welcoming drinks from 5pm, which will be followed by a delicious two course dinner.                        </p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Welcome Dinner</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: '<p><strong>Day 2 - </strong> Hobart, Bruny Island, Hobart</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning we begin your Tasmanian tour with a visit to what is arguably one of Tasmania&s best day tours - the magnificent Bruny Island.                       </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
Our day starts with a 7:30 AM hotel pickup where we leave the early morning hustle and bustle of Hobart City and travel south to the sleepy coastal village of Kettering, where we will board the ferry for a short ride across the tranquil waters of the D'Entrecasteaux Channel to reach the shores of Bruny Island.                       </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
After disembarkation, we proceed to Adventure Bay to check in at 9:30 am for the award-winning Bruny Island Wilderness Cruise. We will explore the rugged coastline of Bruny Island in southern Tasmania, cruise alongside some of Australia's highest sea cliffs, beneath towering crags and drift up close to listen to the awesome 'Breathing Rock'. Enter deep sea caves, pass through the narrow gap between the coast and 'The Monument' and feel the power of nature at the point where the Tasman Sea meets the might of the Southern Ocean. Join in the search for the abundant coastal wildlife such as seals, dolphins, migrating whales and sea birds. The highly trained interpretive guides love what they do - they work hard to ensure that the experience is fun, enjoyable, entertaining and informative.                     </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
After your cruise, we will have lunch at the Bruny Island Cruises Restaurant, we will go on the lookout for the elusive albino wallaby before proceeding to the Neck lookout to experience one of the most iconic images of Bruny Island where the North and South of the island converge at an isthmus. The climb to the top of the lookout involves many steps, but we are rewarded with a magical, 360 degree view of southern Tasmania.                </p>
                        <p class="leading-7 [&:not(:first-child)]:mt-6">
After the climb up the steps to the Neck lookout, we unwind and relax while sampling award-winning local produce of honey, cheese, beverages and oysters, as we meander our way toward the ferry for the drive back to Hobart.                       </p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Bruny Island Wilderness Cruise</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: '<p><strong>Day 3 - </strong> Hobart, Richmond, kunanyi and Mona Museum</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Today, we explore Hobart and surrounds as we uncover the beauty of Australia&s 2nd oldest and southernmost capital city.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Our day begins with a hotel pickup at 8:00 AM where we make a gentle start to the day consisting of a guided commentary loop of Hobart CBD and its iconic landmarks. From there, we proceed up to the summit of kunanyi (Mt Wellington), where you will be greeted by pristine air and the best views of Hobart and the surrounding landscape.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
We descend from the summit of Kunanyi where we arrive at Hobart&s waterfront to the world-renowned Salamanca Markets for morning tea and to explore the 300 fresh produce, bespoke arts and artisan craft stalls that coalesce into Tasmania&s largest selection of locally made products.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After 90 minutes of exploring the markets, we make our way on to Richmond - an iconic township rich in convict history, sandstone and colonial buildings that is home to Australia&s oldest bridge and catholic church. Here there will be an opportunity for lunch from one of the many quaint cafes and shops that line Richmond.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a stop at the Wicked Cheese Company for a sampling of their award winning cheeses, we proceed on to one of the most quirky and controversial places in the world - MONA museum and Moorilla Winery. This awe-inspiring museum will shock, surprise and leave you pondering as you board the MONA ROMA ferry back to the Hobart waterfront, where you will be able to explore this beautiful place at your leisure and make your own way back to the hotel.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Dinner tonight will be your own choice at one of the many restaurants that are within the CBD and waterfront. Some suggestions for beautiful meals in beautiful restaurants: Roaring Grill, Cargo, Ball and Chain, Bar Wa Izakaya, Customs house, Blue Eye, Mures, the Drunken Admiral, or food punts on the waterfront.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> MONA Museum and Ferry</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/mona.jpg'
			},
			{
				title: '<p><strong>Day 4 - </strong> Hobart, Richmond, Port Arthur</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our morning begins with a 9:00 AM hotel pickup before embarking on the relaxing 90 minute drive east past farmlands, vineyards and small country towns toward our destination - Port Arthur and the Tasman Peninsula. En route, we will pull up to the Pirate&s Bay lookout for a photo and to survey our destination.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
A short drive down the road we make our next stop at the Tasmanian Chocolate Foundry for tastings of some of the very unique hand forged chocolates, as well as traditional-style chocolates or an ice cream.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next stop we&ll visit Port Arthur Lavender where you can soak up the aroma as you walk through the fields of this ancient fragrant plant at the family owned and operated farm which overlooks Long Bay on the doorstep of Port Arthur. Explore the gift shop and garden, sample or buy their lavender produce or simply purchase a coffee and morning tea.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next stop, we will have 3 hours to explore Port Arthur Historic Site with a harbour cruise. Here is your opportunity to grab some lunch at the cafe and eateries on site to dine-in or takeaway. Eat as you gaze upon the UNESCO world-heritage listed former penal colony and its buildings.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After exploring the historic site, you will have the option to jump back on the bus and head to the Remarkable Caves. Enjoy the vista from the Maingon Bay lookout, overlooking the Southern Ocean, watch the wild waves crash against the coastal sea cliffs and take in exceptional views of Penguin rocks and the bay. Descend down 115 steps to the view called Remarkable Caves. Surrounded by ancient sandstone cliffs and the view through the cave itself, it is well worth the descent. At certain times of the year, weather conditions and tides will have the water rushing through the cave. Be prepared to get a little wet should the conditions align. For those that would like to spend more time at the historic site, our driver will come back and collect you after the Remarkable Cave visit, giving you 4 hours at the historic site.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
It&s then a short drive to our peaceful waterfront accommodation. Dinner tonight will be at the Lodges restaurant, On the Bay.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Stewarts Bay Lodge</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast and Dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to the Port Arthur Historic Site with a harbour cruise</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/raspberries.jpg'
			},
			{
				title: '<p><strong>Day 5 - </strong> Port Arthur, Freycinet, Bicheno</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
An early start of 7:30 AM will see us leaving Port Arthur for Freycinet National Park, home to the world-famous Wineglass Bay.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
On route, we will call into Kate&s Berry Farm for morning tea as a start to our East Coast adventure. Our main destination will be appearing on the horizon as we travel through the old village of Swansea and skirt around the Apslawn forest reserve toward Freycinet.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Unwind and relax with some lunch at Devil&s Corner Vineyard, and a tasting of the vineyard&s award winning wines. Set the scene while sitting on a sun-drenched deck overlooking the vineyard, The Hazards and Great Oyster Bay.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After fueling up on some delicious food and wine, we&re off to the Freycinet National Park.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
From here you will have 1 of 2 options:
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
For those interested in seeing the iconic Wineglass Bay we will have a group walk up to the lookout. This is classed as a Grade 3, 1.5hr/2.6km return walk consisting of short, steep hill sections, a rough surface and many steps. There is plenty of seating along the track for rest stops and spectacular views.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
For those not looking for longer walks, you can optionally stay with the guide to head on to the Cape Tourville lighthouse short walk (Grade 1) where we can spy out onto the Tasman Sea to potentially spot some migrating whales breaching the surface. We will then head back down to sea level, where some options include relaxing beach walks, and exploring Honeymoon Bay.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After an afternoon at the national park, it&s time to head to our accommodation for the night, Beachfront Bicheno.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Dinner tonight will be at the hotel pub.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Beachfront Bicheno</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast, Lunch and Dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Tasting and lunch at Devil's Corner Vineyard</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/salmon-ponds.jpg'
			},
			{
				title: '<p><strong>Day 6 - </strong> Freycinet, St Helens</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our morning will start at 9:30 AM, heading to the East Coast Nature World wildlife sanctuary for our first stop. The sanctuary is home to many native species from Tasmanian Devils, Wombats, Wallabies, Forester Kangaroos, Spotted Quolls, reptiles and many more. You will have the opportunity to hand-feed some of the local residents, with a chance to watch a Tassie Devil feeding. A light morning tea will be available from the cafe at Nature World before venturing onward.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Now it is time to venture back to the little fishing village of Bicheno where we will call into the local Blowhole, a drive through of its main sights on our way to our lunch spot, the Lobster Shack. Boasting arguably the best dining location in Bicheno, the Lobster Shack is a boutique, farm gate style eatery overlooking the majestic ‘Gulch& in Bicheno, where Lobster really is the hero!
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
We resume our trip northward up the east coast where old farm homesteads meet the wilds of the Tasman sea until we reach Ironhouse Brewery situated on the wind and sea battered shoreline. Here we will have a guided tour of Ironhouse and a tasting of some of the most extraordinary and delicious craft beers, whiskeys, spirits and wines.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a relaxing afternoon at Ironhouse, we will continue on to the fishing town of St Helens. Here is where we will stay at the newly constructed Tasman Holiday Park. Tonight we will enjoy a free night to explore St Helen&s.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Tasman Holiday Park</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast, Lunch and Dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to East Coast Nature World Wildlife Sanctuary, tour and tasting at Ironhouse Brewery</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/cider.jpg'
			},
			{
				title: '<p><strong>Day 7 - </strong> St Helens, Launceston</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our morning begins at 9 AM with a short drive up the coast to explore and discover first-hand why Lonely Planet declared this to be one of the world&s “Most Beautiful Beaches” and how this coastline came to be named the “Bay of Fires.” For the daring, the opportunity for a quick, refreshing dip in the crystal clear waters of Binalong bay is a must.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With fresh sea air (and a bit of sand) in our hair, we will make a track inland to the idyllic dairy country town of Pyengana where we will pull up to the Pyengana Dairy Farmgate cafe for a cheese tasting.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next up, we watch as the green pastures and grazing dairy cows give way to the densely wooded hills of the St Columba Falls State Reserve of which we travel into the heart of to discover the seldom visited and one of Tasmania&s highest waterfalls. A beautiful, short stroll (Grade 1, 20 min/1 km return) over a hard compacted trail surface which weaves down through a forest of tree ferns, sassafras, beech, myrtle and what was once prime Tasmanian Tiger habitat to the base of the falls. The fine mist will refresh and invigorate you as you stand at the base of the 90m+ waterfall. Although a Tasmanian Tiger is unlikely to be spotted, a sharp eye may spy on another elusive character as it rummages around the creeks for yabbies: the platypus.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Refreshed by the walk and an appetite built up, we will move on to the Pub In The Paddock - a quintessentially Tasmanian experience at a heritage listed pub that is quite literally in the middle of a paddock - for lunch and a beer or two. This pub has a unique resident drinking partner called Priscilla, the beer guzzling pig (“special ales” only). So while you await your meal, grab a couple of brews for you and Priscilla to chug on while overlooking the beautiful and lush, forest encapsulated pastoral valley.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a hearty country pub meal, we make for another superbly contrasting colour landscape - Bridestowe Lavender Estate. Bridestowe is a large lavender farm where the hillsides are lined with thousands of rows of lavender that, when in flower, strikingly contrasts with the rich, red soil and big open sky. The ultimate photo opportunity while testing your taste buds on beautiful lavender ice cream.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With the day beginning to set, we travel toward Launceston, the heart of the Tamar Valley wine region and our overnight hotel. Tonight, dinner will be in the hotel restaurant.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor Launceston</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast and Dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Tasting at Pyengana Dairy Farmgate cafe</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			},
			{
				title: '<p><strong>Day 8 - </strong> Launceston</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Today is our recovery day where we take it a little slower to indulge in beautiful local produce, fine wine and relaxation in the newly crowned UNESCO gastronomy region.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
First off, we make our way to Launceston's Cataract Gorge - a local favourite on a sunny day, where you can choose to ride the single-span chairlift across the gorge or stroll around the grounds with the peacocks and native wildlife or grab some morning tea at the cafe to ease into the day.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
From Cataract Gorge, we travel across the strikingly white Batman bridge over to the western shore and through to Beauty Point. Here we visit either Seahorse World or Platypus House for an up close encounter with these extraordinary creatures. While you are left pondering how on earth a platypus came to be, we will travel through the gold mining town of Beaconsfield and past its gold mine - the site of the tragic 2006 mine collapse and subsequent rescue of miners.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
From Beaconsfield, we continue back through the Tamar Valley wine region where we will stop to relax over lunch and a tasting of some of the world's best cool climate wines.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With the savouring taste of beautiful wine and produce lingering, we make our way back to our Launceston hotel to where we can spend free time to freshen up, head out for a short exploration of the city centre and/or the local city park. Tonight, you will have the opportunity to explore Launceston and eat out wherever you wish.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor Launceston</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast and Lunch</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to Seahorse World or Platypus House</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			},
			{
				title: '<p><strong>Day 9 - </strong> Launceston, Cradle Mountain</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning sees us embark for the majesty of Cradle Mountain. Our morning begins at 08:00 AM where we make for Tasmania&s outdoor art gallery - Sheffield, where over 150 murals line the walls throughout the town. Here is a great opportunity to grab a coffee, some morning tea and stretch the legs while admiring the artwork.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With the foothills of Mt Roland as our compass point, we move on toward Cradle Mountain National Park. Upon arrival we will be greeted by the visitor centre where we will check in to the park before making our way on to the jewel in the Cradle - Dove Lake. Here we will spend an hour exploring the lake and an opportunity to have a light pre-packed lunch on the shores of the lake.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Our next stop will be at Waldheim Chalet and Weindorfers Forest Walk (Grade 2, 750m/20 min loop) where we will uncover the colourful history of the Weindorfers. Following out of the chalet leads to what is a lovely, winding stroll through a rainforest, where ancient King Billy pines, pandani and Tasmania's renowned deciduous beech (fagus) reside amongst many varieties of colourful fungi and mosses. One could be forgiven for believing that they have stumbled into a fairy tale forest.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With a goodbye to the Weindofer&s chalet, we head up to the Interpretation Centre and Peppers Lodge where we can optionally take multiple short walks through the Enchanted forest walk (Grade 2, 20min/1.1km circuit) and the Pencil Pine Falls Rainforest walk that encircles the Interpretation Centre. For those with a little more left in the tank, the King Billy track (Grade 2, 40 min/2 km circuit) is a boardwalk trail that rambles through the old temperate rainforest to discover myrtle, sassafras and ancient King Billy pines up to 4000 years of age.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next we head off to our overnight destination. The Tullah Lakeside Lodge, positioned right on the banks of Lake Rosebery, is set in the heart of Tasmania&s wild west. Dinner will be at the Lodge&s Lakeside Bar & Grill.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Tullah Lakeside Lodge</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast, Lunch and Lunch</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Parks pass to Cradle Mountain National Park</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			},
			{
				title: '<p><strong>Day 10 - </strong> Tullah, Strahan</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Today you will have the opportunity to choose one of two award winning activities - The Gordon River Cruise or the West Coast Wilderness Railway.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
Option 1 - Gordon River Cruise
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Step aboard Spirit of the wild and glide through the UNESCO Tasmanian Wilderness World Heritage Area. Take in the tranquil surroundings of the Gordon River as you glide across the water in 'Whisper Mode'. Dedicated guides and character-based interpretations will take you through the history of this remarkable place, including Macquarie Harbour, Hells Gates, Heritage Landing and Sarah Island. This is an incredible way to experience the untouched rainforest, rugged history and fascinating characters of Tasmania's west coast.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
Gordon River Cruise Inclusions
</p>
<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
              <li>Quiet cruising on the Gordon River with Spirit of the Wild's unique hybrid system</li>
    <li>First access to the Gordon River ensuring the best possible chance of seeing the famous reflections</li>
    <li>Dedicated on-board guides</li>
    <li>Character-based interpretation during which you'll meet the likes of Captain James Kelly, Lady Jane Franklin and more</li>
    <li>Chef-prepared buffet lunch</li>
    <li>Two walking tours (Heritage Landing and Sarah Island)</li>
    <li>Cash bar on the Main Deck</li>
        </ul>
<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
There is an option to level up your cruise experience and upgrade to the premium deck.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
Premier upper deck additional inclusions
</p>
<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
                 <li>Complimentary Tasmanian red, white and sparkling wines, as well as beers, juices, tea and espresso coffee</li>
    <li>Premium leather recliners with full-length windows</li>
    <li>Private viewing deck and lounge area</li>
    <li>Morning, afternoon tea and canapés</li>
    <li>An additional $151 per person is required to upgrade your booking.</li>
        </ul>
		<p class="leading-7 [&:not(:first-child)]:mt-6 ">
After the cruise we will return to our accommodation.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
Option 2 - West Coast Wilderness Railway
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Travel south to the mining town of Queenstown where we will proceed to the Queenstown train Station and the West Coast Wilderness Railway. We will board a beautifully restored steam engine-powered train for a spectacular and often jaw-dropping ride through the mountainous rainforest terrain all enclosed within a luxury carriage. Sections are believed to be the steepest steam hauls in the southern hemisphere. The train stops at various small stations along the way. The experience includes a glass of wine on arrival and light meals served throughout the journey.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6 font-semibold">
West Coast Wilderness Railway Highlights
</p>
<ul class="my-6 ml-6 list-disc [&>li]:mt-2">
                 <li>Journey deep into western Tasmania's cool temperate rainforest.</li>
    <li>Pan for gold at Lynchford Station – named after prospector Cornelius Lynch, who found a gold nugget the size of a cricket ball here in the 1880s, and sparked the west coast's gold rush.</li>
    <li>Climb the steep mountainside at Rinadeena Saddle, under the power of the Abt rack and pinion system, the only operating Abt rack and pinion railway in the Southern Hemisphere.</li>
    <li>Enjoy stunning views as you traverse the spectacular King River Gorge.</li>
    <li>Take a short walk in the rainforest at Dubbil Barril and see the train being turned on the turntable, before your return journey to Queenstown.</li>
        </ul>
<p class="leading-7 [&:not(:first-child)]:mt-6 ">
After the rail experience, we board the bus for a loop of the main sights of Queenstown before we wind our way back to Strahan.
</p>

		<p class="leading-7 [&:not(:first-child)]:mt-6 ">
Tonight marks the final night of our tour. We will have dinner tonight as a group to celebrate the epic adventure we have had over the last 10 days.
</p>

<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Strahan Village</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast, Lunch and Lunch</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> West Coast Wilderness Railway OR Gordon River Cruise</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			},
			{
				title: '<p><strong>Day 11 - </strong> Strahan, Hobart</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning we will check out of our accommodation and start to make our way along the Lyell Highway into the central highlands and back down into Hobart. Along the way we will stop at the Wall in the Wilderness at Derwent Bridge. The Wall was created over a 15 year period by Greg Duncan, a woodwork sculptor, who set out to carve the history of the highlands in 100 metres of timber, most of which will be in our rare Huon Pine. The beautifully carved works set out in relief sculpture depict the history, hardship and perseverance of the people in the Central Highlands and pay homage to the individuals who settled and protected the area. After our visit to The Wall, we will head to the Derwent Bridge where you will be able to get some lunch.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With the legs stretched, it is time to begin our descent from the highlands, down through the Derwent Valley for our return to Hobart. Upon arrival back into Hobart your tour will come to an end, where your guide can drop you off at the Airport or at your preferred hotel.
</p>

<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to The Wall in the Wilderness</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			}
		]
	},
	{
		productCode: 'PTWH1T', // Replace with your actual product code
		headline: 'Tasmania for the thrillseekers',
		description: `
	        <p class="leading-7 [&:not(:first-child)]:mt-6">
	Welcome to Tassie Tours, the ultimate destination for adventure enthusiasts and thrill seekers! Our all-inclusive adventure tour offers an adrenaline-filled journey through the breathtaking landscapes of Tasmania. Get ready to experience the rush of whitewater rafting, mountain biking, kayaking, hiking, ATV adventures, and more, all while indulging in the finest local produce.		</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Get ready for a journey that will take you to the heart of Tasmania's natural wonders. From the rugged terrains of Maydena, where you'll conquer mountain biking trails and discover hidden gems, to paddling through crystal-clear waters along the pristine coastline of Freycinet National Park, while you marvel at the diverse marine life, and soak in the serenity of Australia's most beautiful beaches.		</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	We'll treat your taste buds throughout the tour to the finest local produce, wines, whiskies, and seafood. Indulge in award-winning delicacies, savour the flavours of Tasmania, and experience the culinary delights that this region is renowned for.			</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Book your spot on our adventure-filled tour in Tasmania today and get ready for the thrill of a lifetime!		</p>

	        `,
		features: [
			{
				title: 'Transport',
				image: '/src/lib/assets/illustrations/transport.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>Small group touring</li>
    				<li>max 12 travellers</li>
				</ul>`
			},
			{
				title: 'Guides',
				image: '/src/lib/assets/illustrations/planning.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>1 - 3 guides throughout your tour</li>
				</ul>`
			},
			{
				title: 'Accommodation',
				image: '/src/lib/assets/illustrations/resting.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>6 nights accommodation in 3 star hotels and cabin park</li>
    				<li>Upgrading to 4 and 5 star hotels and cabins are available based on availability</li>
				</ul>
				<p class="leading-7 [&:not(:first-child)]:mt-4 text-xs italic">
	(Single supplement available)</p>`
			},
			{
				title: 'Activities',
				image: '/src/lib/assets/illustrations/bike.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   <li>Maydena Bike Park pass and bike hire</li>
<li>White water rafting the King River</li>
<li>West Coast Wilderness Railway</li>
<li>Cradle Mountain Canyoning</li>
<li>Hike to Mt Amos and Wineglass Bay lookout with Freycinet Adventrues</li>
<li>Kayaking around The Hazards at Freycinet</li>
<li>4x4 All-terrain tour with ALL4</li>
<li>Wineglass Bay cruise - includes morning tea, lunch and beverages</li>
<li>National Park Passes for Mt Field National Park, Freycinet & Cradle Mountain</li>
				</ul>`
			}
		],
		accordionHeadline: 'Itinerary',
		accordionContent: [
			{
				title: '<p><strong>Day 1 - </strong> Hobart to Maydena</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Welcome to day 1 of your Tassie adventure! Our journey begins as we pick you up from your hotel and embark on a scenic drive through the picturesque Derwent Valley, heading towards Maydena.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Upon arrival, the experienced team from Maydena Bike Park will ensure you are fully equipped and ready to conquer the trails. These trails have been meticulously crafted by Dirt Art, a renowned Tasmanian trail company. With over 73 individual trails to choose from, ranging from beginner-friendly rides to challenging wilderness and pro trails, Maydena Bike Park offers an unparalleled experience. Each trail takes advantage of the park's unique rainforest environment and impressive 820m vertical elevation, catering to riders of all abilities.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Once you're geared up and ready to go, get ready for a full day of exploring the breathtaking beauty of Maydena Bike Park. As you ride, take in the stunning surroundings and immerse yourself in the natural wonders of Tasmania's Derwent Valley. When you need a break, enjoy the finest local produce at the park's cafe and restaurant, showcasing the flavours of the region.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After an exhilarating day on the trails, we'll transport you back to our accommodation for the night. The evening is yours to savour, whether you choose to dine, unwind with a drink, or explore the surrounding area.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

									<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Mountain bike hire and 1day uplift pass</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: '<p><strong>Day 2 - </strong> Maydena, Mt Field, Strahan</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Prepare for a relaxed morning as we immerse ourselves in the breathtaking Mt Field National Park. Renowned for its diverse landscapes and breathtaking beauty, this park boasts towering mountain peaks, ancient rainforests, and waterfalls. Our exploration will take us along various walking tracks, including the renowned Russell Falls Track.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After some time in Mt Field, we hit the road, venturing west through the central highlands. Our first stop is Derwent Bridge, where we will visit the remarkable Wall in the Wilderness. Crafted over a span of 15 years by the talented woodwork sculptor Greg Duncan, this masterpiece spans 100 meters and tells the story of the highlands. Carved predominantly from rare Huon Pine, the relief sculptures depict the history, resilience, and struggles of the people who shaped and protected this region. It is a tribute to their indomitable spirit.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Continuing our journey, we arrive at the charming coastal town of Strahan. Here, we check into our hotel before heading out to Henty Dunes. Rising up to 30 meters tall and stretching several kilometres inland, these colossal sand dunes create a desert-like oasis amidst the lush rainforests of Tasmania's west coast. We will relish the opportunity while on the west to have a picnic dinner while basking in the mesmerizing sunset, surrounded by the beauty of this unique landscape.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> National Park Pass, Entry to The Wall in the Wilderness</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: '<p><strong>Day 3 - </strong> Strahan, Cradle Mountain</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning we depart for Queenstown to partake in the King River Gorge, Raft and Steam Experience. This extraordinary collaboration between King River Rafting and the West Coast Wilderness Railway seamlessly combines the thrill of white water rafting with the historical charm of a heritage steam train ride.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Our rafting journey will begin on the awe-inspiring King River, surrounded by the majestic West Coast Range mountains. Navigating through 7km of the King River Gorge's captivating rapids, we will venture from Newall Creek to Dubbil Barril, passing through a remote rainforest gorge adorned with ancient Huon Pine trees.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Along the way, we will catch glimpses of the West Coast Wilderness Railway. Continuing downstream, we will catch up with the train at Dubbil Barril Station. The return steam train ride will guide us out of the gorge back towards Queenstown. The train will make a stop at Rinadeena, providing a water stop for the train and a nice hot drink for us.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
We will regroup on the bus and make a stop for lunch. Reenergized, we continue our journey towards Cradle Mountain National Park. Once we arrive, we’ll check into our accommodation and enjoy the evening by the fire or maybe out under the stars.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> White water rafting and steam railway experience</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/mona.jpg'
			},
			{
				title: '<p><strong>Day 4 - </strong> Cradle Mountain</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning we will offer those interested in an early morning walk the opportunity to head up to Dove Lake. This 6km track is surely one of the premier walks in Tasmania. Starting from Dove Lake, a glacially carved lake directly beneath Cradle Mountain, the walk offers both intimate and epic views of the famous mountain. The track undulates around Dove Lake, traverses beneath the mountain, and then returns through the magnificent rainforest to the starting point. The walk takes you through some of Tasmania's special vegetation, from button grass to myrtle, sassafras, Fagus and King Billy pine. Walk in a clockwise direction.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Then it’s over to our friends from Cradle Mountain Canyons who are going to take you on an accelerating tour at Dove Canyon.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Dove Canyon is Tassie adventure at its best. We walk through the pristine rainforest to this stunning canyon. After abseiling in, we spend the day walking and floating through the canyon and doing what we have to do to navigate the obstacles we find along the way. The main obstacles are six waterfalls which we abseil, jump or slide off!
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
One of the highlights is the Laundry Chute - a ten-metre high natural slide that shoots you out of a large cave (which we call The Pit) into a big open pool. Very unique and highly exhilarating.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
This is a committing trip - once you're in, there's only one way out and there is no way to walk around any of the waterfalls. Having said that, most of our clients have no canyoning experience, and it doesn't require any particular skills as such - just an ability to swim and a sense of adventure.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
You do need a decent level of fitness. The hardest part of the day physically is the hike out of the canyon. It is 20 minutes, up a steep hill, in a wetsuit, to get back to where our dry clothes are waiting for us.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
This evening we kick back and enjoy another night in the Cradle Mountain National Park.</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Cradle Mountain Canyoning full day experience</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/raspberries.jpg'
			},
			{
				title: '<p><strong>Day 5 - </strong> Cradle Mountain, Freycinet</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning you will have one more opportunity to explore the Cradle Mountain National Park before we head east towards Freycinet National Park. We have a long drive ahead of us but we will make a few stops along the way to break up the journey.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
When we arrive in to Coles Bay, Freycinet, it’s time to throw on the hiking boots and get those legs moving again as we’re going to conquer Mt Amos. Mount Amos is part of the range of granite mountains, known as the Hazards, which dominate Coles Bay and Freycinet National Park. The track to the summit is steep and strenuous, but walkers are rewarded with panoramic views. This hike takes around 2 hours to complete.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After we make it back down to sea level we’ll head back to our accommodation for the evening.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> National Parks Pass, Mt Amos or Wineglass Bay walk</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/salmon-ponds.jpg'
			},
			{
				title: '<p><strong>Day 6 - </strong> Freycinet</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning we make our way to the waterfront as our partners at Freycinet Adventure take you on a relaxing paddle around the Freycinet Peninsula.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
On this relaxed guided tour of the Freycinet coastline, you’ll glide beneath pink granite mountains, past pristine sandy beaches and across waters so clear you feel you can touch the marine life below. You’ll experience Freycinet’s abundant wildlife as you weave along the coastline. Our guides share little known stories of the area and give you the chance to find out some fantastic facts. We stop half way through on a secluded sandy beach for a freshly brewed cup of coffee and a tasty snack.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Our tours are run in small groups which means you have the chance to ask questions along the way.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
All you need to wear is comfortable clothing, you will be provided with warm jackets if required. Your footwear will get wet so we recommend flip flops/sandals or bare feet.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a morning on the water, we will grab a bite to eat before we move on to our next activity.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
The crew at ALL4 are going to be taking you on an unforgettable and fun adventure. Based in the seaside town of Coles Bay on Tasmania’s East Coast, ALL4 operates in one of the World’s most spectacular National Parks, Freycinet. Specialising in small, intimate adventure tours, ALL4’s vehicles allow us to share hidden, often otherwise inaccessible locations within the park, enabling you to experience the wonder of Freycinet in ways that few people will ever have the opportunity to do. Jump on board a 2 seater Honda Pioneer ATV as you wind your way through eucalypt covered hills, boulder strewn valleys and coastal heath, to where red granite, blue seas and fine white sands collide at South Friendly Beaches. Or head to the dramatic sea cliffs of Cape Tourville for panoramic views of the Freycinet Peninsula and a glimpse of Wineglass Bay. It’s an experience you’ll never forget.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a day of exploring the sea and land it’s time to kick back and enjoy the evening.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Freycinet Kayaking and ATV adventure tour</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/cider.jpg'
			},
			{
				title: '<p><strong>Day 7 - </strong> Freycinet, Hobart</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
After a massive 6 days of bike riding, rafting, canyoning, hiking, kayaking, and all-wheel driving, it’s time to unwind with a cruise into Wineglass Bay. Wineglass Bay Cruises is a 4½ hour cruise of the waterways surrounding Freycinet National Park from Coles Bay to Wineglass Bay on Tasmania's East Coast.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Cruise the spectacular coastline of Freycinet National Park from Coles Bay to Wineglass Bay. Be enthralled by the stunning granite coastline, including the dramatic pink peaks of the Hazards range.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Discover a coast dotted with sparkling white sand beaches, including Cooks and Bryans beaches, only accessible by water or a full day bushwalk. Explore the inner passage of remote Schouten Island, home to little penguins and short tailed shearwaters, before heading into the Tasman Sea towards Wineglass Bay. Look out for various hidden sea caves, blowholes and waterfalls amongst the sheer granite cliffs.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Uncover the rich history of the region, including aboriginal heritage and tales of early explorers and entrepreneurs.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After our cruise, we will make our way back to Hobart. Along the way, we will stop off at Devils Corner for a tasting and an opportunity to reflect on the incredible adventure you have been on.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
We will arrive back in Hobart at approximately 5:30 PM.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Wineglass Bay cruise</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			}
		]
	},
	{
		productCode: 'PVHGUQ', // Replace with your actual product code
		headline: 'Tour Description',
		description: `
	        <p class="leading-7 [&:not(:first-child)]:mt-6">
	Join this fully inclusive tour of Tasmania’s East with our friendly, local and knowledgeable guides for 8 days and 7 nights. This unforgettable experience will leave no stone unturned, embracing everything Tasmania’s East Coast has to offer.		</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Witness our dramatic coastlines, rare and remarkable wildlife in their natural habitat, rich convict history, eccentric art scene and eclectic food range. We can assure you there is something for everyone on this unique island down under.		</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Travel through the most spectacular regions of this extraordinary island state, taking in all the highlights from inspiring wildlife sanctuaries, beautiful winery regions, picturesque beaches, to wondrous cruises, World Heritage listed convict sites and small historic villages.		</p>
				<p class="leading-7 [&:not(:first-child)]:mt-6">
	Delve deep and uncover Tasmania's vast wilderness and untouched national parks, covered with a diversity of unspoiled habitats and ecosystems, you will experience first hand the natural, ancient beauty these places have to offer.		</p>
 <blockquote class="mt-6 border-l-2 pl-6 italic">
 ROAMING20 discount code applies exclusively to the 8-day tour from April 3-10, 2024. Limited time offer. Not valid with any other promotions.
  </blockquote>

	        `,
		features: [
			{
				title: 'Transport',
				image: '/src/lib/assets/illustrations/transport.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>Small group touring</li>
    				<li>max 24 travellers</li>
				</ul>`
			},
			{
				title: 'Guides',
				image: '/src/lib/assets/illustrations/planning.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>1 - 3 guides throughout your tour</li>
				   	<li>With alternating guides you will get the diverse knowledge perspective of different local experts</li>
				</ul>`
			},
			{
				title: 'Accommodation',
				image: '/src/lib/assets/illustrations/resting.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>Great twin share accommodation</li>
    				<li>5 nights 4 star hotels</li>
    				<li>2 nights 4 star cabin parks</li>
				</ul>
				<p class="leading-7 [&:not(:first-child)]:mt-4 text-xs italic">
	(Single supplement available)</p>`
			},
			{
				title: 'Food and Drink',
				image: '/src/lib/assets/illustrations/food.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				   	<li>7 Breakfasts</li>
    				<li>3 Lunches</li>
    				<li>5 Dinners</li>
    				<li>2 Wine/Whisky tastings</li>
    				<li>4 Produce samplings</li>
				</ul>
				<p class="leading-7 [&:not(:first-child)]:mt-4 text-xs italic">
	(Single supplement available)</p>`
			},
			{
				title: 'Activities',
				image: '/src/lib/assets/illustrations/bike.png',
				content: `<ul class="ml-6 list-disc [&>li]:mt-2">
				      <li>Bruny Island Wilderness Cruise</li>
    <li>MONA Museum and Ferry</li>
    <li>Port Arthur Historic Site and harbor cruise</li>
    <li>East Coast Nature World</li>
    <li>Seahorse World OR Platypus House</li>
    <li>National Park Pass for Freycinet</li>
				</ul>`
			}
		],
		accordionHeadline: 'Itinerary',
		accordionContent: [
			{
				title: '<p><strong>Day 1 - </strong>Arrivals day in Hobart</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our arrivals day is for passengers to settle into Hobart and unwind in their centrally located accommodation.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
In the evening feel free to say hello to our team and fellow guests who you will be travelling with for the next 10 days. There will be welcoming drinks from 5pm, which will be followed by a delicious two course dinner.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor</p>
								</div>

								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Welcome Dinner</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: '<p><strong>Day 2 - </strong> Hobart, Bruny Island, Hobart</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
This morning we begin your Tasmanian tour with a visit to what is arguably one of Tasmania’s best day tours - the magnificent Bruny Island.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Our day starts with a 7:30 AM hotel pickup where we leave the early morning hustle and bustle of Hobart City and travel south to the sleepy coastal village of Kettering, where we will board the ferry for a short ride across the tranquil waters of the D'Entrecasteaux Channel to reach the shores of Bruny Island.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After disembarkation, we proceed to Adventure Bay to check in at 9:30 am for the award-winning Bruny Island Wilderness Cruise. We will explore the rugged coastline of Bruny Island in southern Tasmania, cruise alongside some of Australia's highest sea cliffs, beneath towering crags and drift up close to listen to the awesome 'Breathing Rock'. Enter deep sea caves, pass through the narrow gap between the coast and 'The Monument' and feel the power of nature at the point where the Tasman Sea meets the might of the Southern Ocean. Join in the search for the abundant coastal wildlife such as seals, dolphins, migrating whales and sea birds. The highly trained interpretive guides love what they do - they work hard to ensure that the experience is fun, enjoyable, entertaining and informative.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After your cruise, we will have lunch at the Bruny Island Cruises Restaurant, we will go on the lookout for the elusive albino wallaby before proceeding to the Neck lookout to experience one of the most iconic images of Bruny Island where the North and South of the island converge at an isthmus. The climb to the top of the lookout involves many steps, but we are rewarded with a magical, 360 degree view of southern Tasmania.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After the climb up the steps to the Neck lookout, we unwind and relax while sampling award-winning local produce of honey, cheese, beverages and oysters, as we meander our way toward the ferry for the drive back to Hobart.</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Bruny Island Wilderness Cruise</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/russell-falls.jpg'
			},
			{
				title: '<p><strong>Day 3 - </strong> Hobart, Richmond, kunanyi and MONA Museum</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Today, we explore Hobart and surrounds as we uncover the beauty of Australia’s 2nd oldest and southernmost capital city.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Our day begins with a hotel pickup at 8:00 AM where we make a gentle start to the day consisting of a guided commentary loop of Hobart CBD and its iconic landmarks. From there, we proceed up to the summit of kunanyi (Mt Wellington), where you will be greeted by pristine air and the best views of Hobart and the surrounding landscape.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
We descend from the summit of Kunanyi where we arrive at Hobart’s waterfront to the world-renowned Salamanca Markets for morning tea and to explore the 300 fresh produce, bespoke arts and artisan craft stalls that coalesce into Tasmania’s largest selection of locally made products.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After 90 minutes of exploring the markets, we make our way on to Richmond - an iconic township rich in convict history, sandstone and colonial buildings that is home to Australia’s oldest bridge and catholic church. Here there will be an opportunity for lunch from one of the many quaint cafes and shops that line Richmond.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a stop at the Wicked Cheese Company for a sampling of their award winning cheeses, we proceed on to one of the most quirky and controversial places in the world - MONA museum and Moorilla Winery. This awe-inspiring museum will shock, surprise and leave you pondering as you board the MONA ROMA ferry back to the Hobart waterfront, where you will be able to explore this beautiful place at your leisure and make your own way back to the hotel.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Dinner tonight will be your own choice at one of the many restaurants that are within the CBD and waterfront. Some suggestions for beautiful meals in beautiful restaurants: Roaring Grill, Cargo, Ball and Chain, Bar Wa Izakaya, Customs house, Blue Eye, Mures, the Drunken Admiral, or food punts on the waterfront.</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> MONA Museum and Ferry back to Hobart</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/mona.jpg'
			},
			{
				title: '<p><strong>Day 4 - </strong> Hobart, Port Arthur</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our morning begins with a 9:00 AM hotel pickup before embarking on the relaxing 90 minute drive east past farmlands, vineyards and small country towns toward our destination - Port Arthur and the Tasman Peninsula. En route, we will pull up to the Pirate’s Bay lookout for a photo and to survey our destination.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
A short drive down the road we make our next stop at the Tasmanian Chocolate Foundry for tastings of some of the very unique hand forged chocolates, as well as traditional-style chocolates or an ice cream.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next stop we’ll visit Port Arthur Lavender where you can soak up the aroma as you walk through the fields of this ancient fragrant plant at the family owned and operated farm which overlooks Long Bay on the doorstep of Port Arthur. Explore the gift shop and garden, sample or buy their lavender produce or simply purchase a coffee and morning tea.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next stop, we will have 3 hours to explore Port Arthur Historic Site with a harbour cruise. Here is your opportunity to grab some lunch at the cafe and eateries on site to dine-in or takeaway. Eat as you gaze upon the UNESCO world-heritage listed former penal colony and its buildings.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After exploring the historic site, you will have the option to jump back on the bus and head to the Remarkable Caves. Enjoy the vista from the Maingon Bay lookout, overlooking the Southern Ocean, watch the wild waves crash against the coastal sea cliffs and take in exceptional views of Penguin rocks and the bay. Descend down 115 steps to the view called Remarkable Caves. Surrounded by ancient sandstone cliffs and the view through the cave itself, it is well worth the descent. At certain times of the year, weather conditions and tides will have the water rushing through the cave. Be prepared to get a little wet should the conditions align. For those that would like to spend more time at the historic site, our driver will come back and collect you after the Remarkable Cave visit, giving you 4 hours at the historic site.</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
It’s then a short drive to our peaceful waterfront accommodation. Dinner tonight will be at the Lodges restaurant, On the Bay.</p>

<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Stewarts Bay Lodge</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast and dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to the Port Arthur Historic Site with a harbour cruise</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/raspberries.jpg'
			},
			{
				title: '<p><strong>Day 5 - </strong> Port Arthur, Freycinet, Bicheno</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
An early start of 7:30 AM will see us leaving Port Arthur for Freycinet National Park, home to the world-famous Wineglass Bay.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
On route, we will call into Kate’s Berry Farm for morning tea as a start to our East Coast adventure. Our main destination will be appearing on the horizon as we travel through the old village of Swansea and skirt around the Apslawn forest reserve toward Freycinet.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Unwind and relax with some lunch at Devil’s Corner Vineyard, and a tasting of the vineyard’s award winning wines. Set the scene while sitting on a sun-drenched deck overlooking the vineyard, The Hazards and Great Oyster Bay.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After fueling up on some delicious food and wine, we’re off to the Freycinet National Park.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
From here you will have 1 of 2 options:
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
For those interested in seeing the iconic Wineglass Bay we will have a group walk up to the lookout. This is classed as a Grade 3, 1.5hr/2.6km return walk consisting of short, steep hill sections, a rough surface and many steps. There is plenty of seating along the track for rest stops and spectacular views.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
For those not looking for longer walks, you can optionally stay with the guide to head on to the Cape Tourville lighthouse short walk (Grade 1) where we can spy out onto the Tasman Sea to potentially spot some migrating whales breaching the surface. We will then head back down to sea level, where some options include relaxing beach walks, and exploring Honeymoon Bay.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After an afternoon at the national park, it’s time to head to our accommodation for the night, Beachfront Bicheno.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Dinner tonight will be at the hotel pub.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Beachfront Bicheno</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast, lunch and dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Tasting and lunch at Devil's Corner Vineyard</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/salmon-ponds.jpg'
			},
			{
				title: '<p><strong>Day 6 - </strong> Freycinet, St Helens</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our morning will start at 9:30 AM, heading to the East Coast Nature World wildlife sanctuary for our first stop. The sanctuary is home to many native species from Tasmanian Devils, Wombats, Wallabies, Forester Kangaroos, Spotted Quolls, reptiles and many more. You will have the opportunity to hand-feed some of the local residents, with a chance to watch a Tassie Devil feeding. A light morning tea will be available from the cafe at Nature World before venturing onward.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Now it is time to venture back to the little fishing village of Bicheno where we will call into the local Blowhole, a drive through of its main sights on our way to our lunch spot, the Lobster Shack. Boasting arguably the best dining location in Bicheno, the Lobster Shack is a boutique, farm gate style eatery overlooking the majestic ‘Gulch’ in Bicheno, where Lobster really is the hero!
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
We resume our trip northward up the east coast where old farm homesteads meet the wilds of the Tasman sea until we reach Ironhouse Brewery situated on the wind and sea battered shoreline. Here we will have a guided tour of Ironhouse and a tasting of some of the most extraordinary and delicious craft beers, whiskeys, spirits and wines.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a relaxing afternoon at Ironhouse, we will continue on to the fishing town of St Helens. Here is where we will stay at the newly constructed Tasman Holiday Park. Tonight we will enjoy a free night to explore St Helen’s.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Tasman Holiday Park</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast, lunch and dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to East Coast Nature World Wildlife Sanctuary, tour and tasting at Ironhouse Brewery</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/cider.jpg'
			},
			{
				title: '<p><strong>Day 7 - </strong> St Helens, Launceston</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Our morning begins at 9 AM with a short drive up the coast to explore and discover first-hand why Lonely Planet declared this to be one of the world’s “Most Beautiful Beaches” and how this coastline came to be named the “Bay of Fires.” For the daring, the opportunity for a quick, refreshing dip in the crystal clear waters of Binalong bay is a must.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With fresh sea air (and a bit of sand) in our hair, we will make a track inland to the idyllic dairy country town of Pyengana where we will pull up to the Pyengana Dairy Farmgate cafe for a cheese tasting.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Next up, we watch as the green pastures and grazing dairy cows give way to the densely wooded hills of the St Columba Falls State Reserve of which we travel into the heart of to discover the seldom visited and one of Tasmania’s highest waterfalls. A beautiful, short stroll (Grade 1, 20 min/1 km return) over a hard compacted trail surface which weaves down through a forest of tree ferns, sassafras, beech, myrtle and what was once prime Tasmanian Tiger habitat to the base of the falls. The fine mist will refresh and invigorate you as you stand at the base of the 90m+ waterfall. Although a Tasmanian Tiger is unlikely to be spotted, a sharp eye may spy on another elusive character as it rummages around the creeks for yabbies: the platypus.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
Refreshed by the walk and an appetite built up, we will move on to the Pub In The Paddock - a quintessentially Tasmanian experience at a heritage listed pub that is quite literally in the middle of a paddock - for lunch and a beer or two. This pub has a unique resident drinking partner called Priscilla, the beer guzzling pig (“special ales” only). So while you await your meal, grab a couple of brews for you and Priscilla to chug on while overlooking the beautiful and lush, forest encapsulated pastoral valley.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
After a hearty country pub meal, we make for another superbly contrasting colour landscape - Bridestowe Lavender Estate. Bridestowe is a large lavender farm where the hillsides are lined with thousands of rows of lavender that, when in flower, strikingly contrasts with the rich, red soil and big open sky. The ultimate photo opportunity while testing your taste buds on beautiful lavender ice cream.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With the day beginning to set, we travel toward Launceston, the heart of the Tamar Valley wine region and our overnight hotel. Tonight, dinner will be in the hotel restaurant.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor Launceston</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast and dinner</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Tasting at Pyengana Dairy Farmgate cafe</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			},
			{
				title: '<p><strong>Day 8 - </strong> Launceston</p>',
				content: `<p class="leading-7 [&:not(:first-child)]:mt-6">
Today is our recovery day where we take it a little slower to indulge in beautiful local produce, fine wine and relaxation in the newly crowned UNESCO gastronomy region.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
First off, we make our way to Launceston's Cataract Gorge - a local favourite on a sunny day, where you can choose to ride the single-span chairlift across the gorge or stroll around the grounds with the peacocks and native wildlife or grab some morning tea at the cafe to ease into the day.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
From Cataract Gorge, we travel across the strikingly white Batman bridge over to the western shore and through to Beauty Point. Here we visit either Seahorse World and Platypus House for an up close encounter with these extraordinary creatures. While you are left pondering how on earth a platypus came to be, we will travel through the gold mining town of Beaconsfield and past its gold mine - the site of the tragic 2006 mine collapse and subsequent rescue of miners.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
From Beaconsfield, we continue back through the Tamar Valley wine region where we will stop to relax over lunch and a tasting of some of the world's best cool climate wines.
</p>
<p class="leading-7 [&:not(:first-child)]:mt-6">
With the savouring taste of beautiful wine and produce lingering, we make our way back to our Launceston hotel to where we can spend free time to freshen up, head out for a short exploration of the city centre and/or the local city park. Tonight, you will have the opportunity to explore Launceston and eat out wherever you wish.
</p>
<div class="my-6 flex flex-col gap-8 lg:flex-row">
								<div class="flex items-center gap-2">
									<svg
										class="h-6 w-6 stroke-background"
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										><path d="M2 4v16" /><path d="M2 8h18a2 2 0 0 1 2 2v10" /><path
											d="M2 17h20"
										/><path d="M6 8v9" /></svg
									>
									<p><strong>Accommodation: </strong> Hotel Grand Chancellor Launceston</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path
											d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"
										/></svg
									>
									<p><strong>Included Meals: </strong> Breakfast and lunch</p>
								</div>
								<div class="flex items-center gap-2">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#000000"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="h-6 w-6 stroke-background"
										><path
											d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
										/><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" /></svg
									>
									<p><strong>Included Activities: </strong> Entry to Seahorse World or Platypus House</p>
								</div>
							</div>
`,
				image: '/src/lib/assets/highlights/derwent.jpg'
			}
		]
	}
];
